import React from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import './game-step-text.scss';

const GameStepText = ({languageId, deviceInfo, gameStepData}) => {
	return (
		<div className={'GameStepText ' + deviceInfo.orientation}>
			{gameStepData.title && <div className="GameStepText-title">
				<span>{getText(gameStepData.title, languageId)}</span>
			</div>}
			{gameStepData.text1 && <div className="GameStepText-text1">
				{renderMarkdown(getText(gameStepData.text1, languageId))}
			</div>}
			{gameStepData.text2 && <div className="GameStepText-text2">
				<span>{getText(gameStepData.text2, languageId)}</span>
			</div>}
		</div>
	);
};

GameStepText.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameStepData: PropTypes.object.isRequired
};

export default GameStepText;